import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
// import ExpansionPanel from '@material-ui/core/ExpansionPanel';
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
// import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';

import './WorkoutDescription.css';

const TabContainer = (props) => {
  return (
    <Grid 
      container
      alignItems="flex-start"
      justify="center"
      className="pa4">
      <Grid 
        item
        sm={6}
        xs={12}
        className="children-container tl pr2">
        <Typography component="div" className="f-13">
          {props.children}
        </Typography>
      </Grid>
      <Grid 
        item
        sm={6}
        xs={12}
        className="tl f-13">
        {props.screenWidth > 600 &&
          <div>
            <h4 className="mt0 mb2">
              <Grid container alignItems="center">
                <Grid item>
                  <i className="fab fa-youtube mr1 f5 red"></i>
                </Grid>
                <Grid item>
                  EVENT OVERVIEW VIDEO
                </Grid>
              </Grid>
            </h4>
            <div className="videoWrapper">
              <iframe title="workout-description" src={'https://www.youtube.com/embed/' + props.videoRef} allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe>
            </div>
          </div>
        }
        <h4 className="mt2 mt3-ns mb2"><i className="far fa-sticky-note"></i>   NOTES</h4>
        <p className="mv0 lh-title">{props.notes}<br/>{props.notes2}
          <br /><br />
          {props.example}
        </p>

        <a 
          className="db mv4 mt3-ns mb0-ns"
          target="_blank" 
          href={props.refSheet} 
          rel="noreferrer noopener">
          <Grid container alignItems="center">
            <Grid item>
              <i className="far fa-file-pdf mr1 f5"></i>
            </Grid>
            <Grid item>
              Full event details and standards
            </Grid>
          </Grid>
        </a>
        
        {props.screenWidth <= 600 &&
          <a 
            className="db mv4 mt3-ns mb0-ns"
            target="_blank" 
            href={'https://youtube.com/watch?v=' + props.videoRef} 
            rel="noreferrer noopener">
            <Grid container alignItems="center">
              <Grid item>
                <i className="fab fa-youtube mr1 f5 red"></i>
              </Grid>
              <Grid item>
                Event overview video
              </Grid>
            </Grid>
          </a>
        }
        <a 
          className="db mt2"
          target="_blank" 
          href={'https://www.beyondthewhiteboard.com/workouts/' + props.logId + '/workout_sessions/new'} 
          rel="noreferrer noopener">
          <Grid container alignItems="center">
            <Grid item>
              <i className="fas fa-mobile-alt mr1 f5 "></i>
            </Grid>
            <Grid item>
              Log your score on BTWB
            </Grid>
          </Grid>
        </a>
      </Grid>
    </Grid>
  );
}

class WorkoutDescription extends Component {
  constructor(props) {
    super(props)

    this.state = {
      workoutsOpened: 0,
      screenWidth: 0
    }

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      screenWidth: window.innerWidth
    });

    window.onresize = () => {
      this.setState({
        screenWidth: window.innerWidth
      });
    };
  }

  componentWillUnmount() {

  }

  handleChange(event, panel) {
    if (panel === this.state.workoutsOpened) panel = false;
    this.setState({
      workoutsOpened: panel
    })
  }


  render() {
    return(
      <div>
        <div className="mb4 bg-white ">
          {<AppBar position="static">
            <Paper>
              <Tabs 
                value={this.state.workoutsOpened} 
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="off">
                <Tab label="Friendly Fran" />
                <Tab label="1 Rep Max Front Squat" />
                <Tab label="Damn Diane" />
                <Tab label="1000m Row" />
                <Tab label="Nasty Nancy" />
                <Tab label="Handstand Hold" />
                <Tab label="Awful Annie" />
              </Tabs>
            </Paper>
          </AppBar>}
          <Grid
            container
            justify="center"
            alignItems="center"
            className="modal-header">
            <Grid
              item
              lg={6}
              md={7}
              sm={9}
              xs={12}
              className="mw7 mt1 center">
              {this.state.workoutsOpened === 0 && 
                <TabContainer 
                  videoRef={'mxFsPEogUl4'}
                  notes={'Women: 85-lb Thrusters'}
                  notes2={'Men: 115-lb. Thrusters'}
                  example={'Ex: 1 (7:03)'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://games.crossfit.com/workouts/games/2020#events-details'}
                  logId={'11175263'}>
                  <h4><i className="fas fa-angle-double-right"></i>   3 rounds for time of:</h4>
                  <p>21 Thrusters</p>
                  <p>21 Chest-To-Bar Pull-Ups</p>
                </TabContainer>
              }
              {this.state.workoutsOpened === 1 && 
                <TabContainer 
                  videoRef={'38zvNiOiGnE'}
                  notes={'Women: Go heavy.'}
                  notes2={'Men: Check above.'}
                  example={'Ex: 2 (250 lbs)'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://games.crossfit.com/workouts/games/2020#events-details'}
                  logId={'441'}>
                  <h4><i className="fas fa-angle-double-right"></i>   1 Rep-Max-Front Squat:</h4>
                  <p>Establish a 1-Rep-Max Front Squat</p>
                  <p>Time Cap: 20 minutes</p>
                </TabContainer>
              }{this.state.workoutsOpened === 2 && 
                <TabContainer 
                  videoRef={'Pki0fC3RntI'}
                  notes={'Women: 205-lb. Deadlift, 2-inch deficit'}
                  notes2={'Men: 315-lb. Deadlift, 3.5-inch deficit'}
                  example={'Ex: 3 (2:54)'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://games.crossfit.com/workouts/games/2020#events-details'}
                  logId={'11176173'}>
                  <h4><i className="fas fa-angle-double-right"></i>   3 Rounds for time:</h4>
                  <p>15 Deadlifts</p>
                  <p>15 Strict Deficit Handstand Push-Ups</p>
                </TabContainer>
              }{this.state.workoutsOpened === 3 && 
                <TabContainer 
                  videoRef={'Rc5EGJozQzc'}
                  notes={'Women: Go fast.'}
                  notes2={'Men: Check above.'}
                  example={'Ex: 3 (7:03)'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://games.crossfit.com/workouts/games/2020#events-details'}
                  logId={'2858'}>
                  <h4><i className="fas fa-angle-double-right"></i>   For time:</h4>
                  <p>Row 1000m</p>
                </TabContainer>
              }{this.state.workoutsOpened === 4 && 
                <TabContainer 
                  videoRef={'Pki0fC3RntI'}
                  notes={'Women: 125-lb. overhead squat'}
                  notes2={'Men: 185-lb. overhead squat'}
                  example={'Ex: 4 (7:03)'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://games.crossfit.com/workouts/games/2020#events-details'}
                  logId={'11176948'}>
                  <h4><i className="fas fa-angle-double-right"></i>   5 rounds for time:</h4>
                  <p>500M Run</p>
                  <p>15 Overhead Squats</p>
                  <p>15 Bar-Facing Burpees</p>
                </TabContainer>
              }{this.state.workoutsOpened === 5 && 
                <TabContainer 
                  videoRef={'0WCAmeqQnSE'}
                  notes={'Women: Hold on.'}
                  notes2={'Men: Check above.'}
                  example={'Ex: 4 (7:03)'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://games.crossfit.com/workouts/games/2020#events-details'}
                  logId={'17356'}>
                  <h4><i className="fas fa-angle-double-right"></i>   For max time:</h4>
                  <p>Max Freestanding Handstand Hold</p>
                  <p>Time cap: 20 mins</p>
                </TabContainer>
              }{this.state.workoutsOpened === 6 && 
                <TabContainer 
                  videoRef={'Pki0fC3RntI'}
                  notes={'Women: 185-lb. Clean'}
                  notes2={'Men:  275-lb. Clean'}
                  example={'Ex: 7 (8:45)'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://games.crossfit.com/workouts/games/2020#events-details'}
                  logId={'11181942'}>
                  <h4><i className="fas fa-angle-double-right"></i>   For time:</h4>
                  <p>50-40-30-20-10</p>
                  <p>Double-under</p>
                  <p>GHD sit-up</p>
                  <p>5-4-3-2-1</p>
                  <p>Clean</p>
                </TabContainer>
              }
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }
}

export default WorkoutDescription;